export default __webpack_public_path__ + "media/images/arrow_right-5fdbb85e01f86bd796e1ff3657767f39.gif";